import React, { Component } from "react";
import { Grid as Container, Row, Col, Table } from "react-bootstrap";
import TimeAgo from "timeago-react"; // var TimeAgo = require('timeago-react');

//import timeago from "timeago.js";
import Card from "components/Card/Card.jsx";

//import { thArray, tdArray } from "variables/Variables.jsx";
//timeago.register("pl", require("timeago.js/locales/pl_PL"));

class TableList extends Component {
  state = {
    lastMeasurement: [
      [111, "12-01-2018", "12-01-2018 4:53", "17,5", "12-01-2018 4:53", "17,5"]
    ]
  };

  render() {
    let myArray = [];
    let devicesId = [];
    const thArray = ["Urządzenie", "ID", "SW-wersja", "HW-wersja", "Status"];
    this.props.device.map(device => {
      myArray.push([
        device.desc,
        device.id,
        device.sw_version,
        device.hw_version,
        device.status
      ]);
      devicesId.push(device.id);
    });

    let thLastMeasurement = [
      "Urządzenie",
      "Data ostatniego połączenia",
      "Data pomiaru temperatury",
      "Temperatura",
      "Data pomiaru objętości",
      "Objętość"
    ];

    var trLastMeasurement = [];
    //console.log(this.props.lastMessage);
    devicesId.map((deviceId, key) => {
      let tempDate = new Date(
        1000 * this.props.lastMeasurement[deviceId][1].timestamp
      );
      //tempDate = tempDate.getTime();
      //console.log(tempDate);
      let volumeDate = new Date(
        1000 * this.props.lastMeasurement[deviceId][0].timestamp
      );

      // trLastMeasurement.push([
      //   myArray[key][0],
      //   "2018-01-24 14:53",
      //   tempDate.toLocaleTimeString([], {
      //     hour: "2-digit",
      //     minute: "2-digit"
      //   }) +
      //     "  " +
      //     tempDate.toLocaleDateString(), //new Date(1000 * this.props.lastMeasurement[deviceId][1].timestamp),
      //   this.props.lastMeasurement[deviceId][1].value.toFixed(2),
      //   volumeDate.toLocaleTimeString([], {
      //     hour: "2-digit",
      //     minute: "2-digit"
      //   }) +
      //     "  " +
      //     volumeDate.toLocaleDateString(), //new Date(1000 * this.props.lastMeasurement[deviceId][0].timestamp),
      //   this.props.lastMeasurement[deviceId][0].value.toFixed(2)
      // ]);

      trLastMeasurement.push([
        myArray[key][0],
        "2018-01-24 14:53",
        <TimeAgo datetime={tempDate.getTime()} locale="pl_PL" />,
        this.props.lastMeasurement[deviceId][1].value.toFixed(2),
        <TimeAgo datetime={volumeDate.getTime()} locale="pl_PL" />,
        this.props.lastMeasurement[deviceId][0].value.toFixed(2)
      ]);
    });

    //console.log(trLastMeasurement);
    return (
      <div className="content">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Lista zainstalowanych urządzeń"
                category="Opis"
                ctTableFullWidth
                ctTableResponsive
                ctTableUpgrade
                ctAllIcons
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        {thArray.map((prop, key) => {
                          return <th key={key}>{prop}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {myArray.map((prop, key) => {
                        return (
                          <tr key={key}>
                            {prop.map((prop, key) => {
                              return <td key={key}>{prop}</td>;
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                }
              />
            </Col>
            <Col md={12}>
              <Card
                title="Ostatnio zarejestrowane pomiary"
                category="Opis"
                ctTableFullWidth
                ctTableResponsive
                ctTableUpgrade
                ctAllIcons
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        {thLastMeasurement.map((prop, key) => {
                          return <th key={key}>{prop}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {trLastMeasurement.map((prop, key) => {
                        return (
                          <tr key={key}>
                            {prop.map((prop, key) => {
                              return <td key={key}>{prop}</td>;
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default TableList;



// WEBPACK FOOTER //
// ./src/views/TableList/TableList.jsx